
/**
 * 触发后端函数
 * rootStore
 * options:{
 *   scriptId,
 *   busiObj,
 *   serviceCode,
 * } // 后端脚本参数
 * 
 */

import request from "ynf-core-engine/request";

// const MDF_BE_SCRIPT_PATH = '/mdf-node/uniform'
const MDF_BE_SCRIPT_PATH = '/mdf-node/qtmProxy'
export const invokeBeScript = function (_rootStore: any, options: any) {
  const {
    svcUrl,
    scriptId,
    busiObj,
    serviceCode,
    billNo,
    domainKey
  } = options;
  const { serviceCode: _serviceCode = '' } = _rootStore?.pageStore?.params || {};
  const url = svcUrl ?
    `${MDF_BE_SCRIPT_PATH}${svcUrl}&domainKey=${domainKey}&busiObj=${busiObj}&serviceCode=${serviceCode || _serviceCode}` :
    `${MDF_BE_SCRIPT_PATH}/ypd/script/ruleHandler?scriptId=${scriptId}&domainKey=${domainKey}&busiObj=${busiObj}&serviceCode=${serviceCode || _serviceCode}`
  try {
    request({
      url,
      method: 'post',
      data: {
        billNo,
      },
      params: {},
      headers: {
        domainKey
      }
    });
  } catch (err: any) {
    console.error(err)
  }
}